import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  form: {
    padding: '12px',
    ...dFlex('center', 'center'),
    width: '600px',
    gap: '8px',
  },
  text: {
    paddingLeft: '12px',
    paddingTop: '12px',
  },
}));

export default useStyles;
